<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col class="text-center">
                    <h3 class="text-center">Add Topics by {{ addmethod }} {{ addmethod == 'File' ? 'Upload' : 'Input'}}</h3>
                    <b-button-group size="lg" class="text-center mb-3">
                        <b-button variant="primary" size="lg" @click="addmethod = 'Text'" :class="addmethod == 'Text' ? 'active-method' : 'inactive-method'">Upload by Text</b-button>
                        <b-button variant="primary" size="lg" @click="addmethod = 'File'" class="up-btn" :class="addmethod == 'File' ? 'active-method' : 'inactive-method'">Upload by File</b-button>   
                    </b-button-group>
                    
                </b-col>
                
            </b-row>
            <b-row>
                <b-col v-if="addmethod == 'Text'">
                    <b-card variant="dark" class="h-100">
                        <form @submit.prevent="addTopic">
                            <b-form-group>
                                <b-form-group class="nested-form-group" label="Select Exam Category:" label-for="category">
                                    <!-- 'chkcatarr' checks if the category Array is empty and therefore shows the overlay over this select box instead of letting users bring down an empty select box -->
                                    <b-overlay :show="chkcatarr" rounded opacity="0.6" spinner-type="grow" spinner-small spinner-variant="primary" class="w-100">
                                        <b-form-select v-model="topicObj.category" :options="Categoriesarray" @change="categoryChanged">
                                            <b-form-select-option value="null">--Select category--</b-form-select-option>
                                        </b-form-select>
                                    </b-overlay>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="sameName == 'No'" label="Select Institution" label-for="institution">
                                    <b-form-select v-model="topicObj.institution" @change="institutionChanged" :options="institutionsarray">
                                        <b-form-select-option value="null">--Select Institution--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.institution != null" label="Select Level" label-for="institution">
                                    <b-form-select v-model="topicObj.level" @change="levelChanged" :options="levelsarray">
                                        <b-form-select-option value="null">--Select Level--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.level != null" label="Select Course" label-for="institution">
                                    <b-form-select v-model="topicObj.topicfor" :options="coursesarray">
                                        <b-form-select-option value="null">--Select Course--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Subject' && topicObj.institution != null" label="Select Subject" label-for="institution">
                                    <b-form-select v-model="topicObj.topicfor" :options="subjectOptions">
                                        <b-form-select-option value="null">--Select Subject--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="topicObj.topicfor != null" label="Input in Topic" label-for="institution">
                                    <b-form-input type="text" v-model="topicObj.topic" @focus="added = false"></b-form-input>
                                </b-form-group>
                                <div v-if="added" class="alert alert-success p-3">
                                    Topic added
                                </div>

                                <div class="text-center">
                                    <b-overlay :show="proceeding" rounded opacity="0.6" spinner-small spinner-variant="primary" class="w-100">
                                        <b-button :disabled="!substate" type="submit" class="w-50 p-2 btntxt" variant="warning" @click="proceed">
                                            Proceed
                                        </b-button>
                                    </b-overlay>

                                    <b-button v-if="proceeding" class="w-50 p-2 mt-3 btntxt" variant="dark" @click="stopproceed">
                                        Cancel
                                    </b-button>
                                </div>

                                
                            </b-form-group>
                        </form>
                    </b-card>
                </b-col>
                <b-col v-if="addmethod == 'File'">
                    <b-card>
                        <div class="sqheader p-2 m-1">
                            <div class="heasub"><h3>View .txt File Formatting Rules</h3></div>
                            <div class="sqicon">
                                <b-icon-plus font-scale="2.5" v-if="showplus" @click="showplus = false;showformatting = true; showminus = true" class="sqbicon"></b-icon-plus>

                                <b-icon-dash font-scale="2.5" v-if="showminus" @click="showformatting = false; showminus = false; showplus = true " class="sqbicon"></b-icon-dash>
                            </div>
                        </div>
                        <div v-if="showformatting">
                            <ul>
                                <li>Each Topic must take up 1 line and no space at the end seperating it from the next Topic.</li>
                                <li>Select all Fields Provided in the Form.</li>
                                <li>Each field must not span two lines. If there's any need for a new line within a line the line break character &lt;br&gt; should be placed at that point</li>
                            </ul>
                            <h3 class="mt-3">Good .txt File Formatting Method for adding Topics</h3>
                            <b-card class="txtcode" bg-variant="dark" text-variant="light">
                                <code>
                                    <p class="txtformat">Organic Chemistry : Aroma Hydrocarbons It is Imperative that we do it the right way</p>
                                    <p class="txtformat">Inert Gases</p>
                                </code>
                            </b-card>
                            <h3 class="mt-3">Bad .txt File Formatting Method for adding Topics</h3>
                            <b-card class="txtcode" bg-variant="dark" text-variant="light">
                                <code>
                                    <p class="txtformat">Topic: Organic Chemistry : Aroma Hydrocarbons It is Imperative that we do it the right way</p>
                                    <p class="txtformat">Topic :Inert Gases</p>
                                </code>
                            </b-card>
                        </div>
                        <div v-if="mtype == 'added'" class="alert alert-success">Topic{{ topicscount > 1 ? 's' : ''}} has been added to the database</div>
                        <b-form-group class="nested-form-group" label="Select Exam Category:" label-for="category">
                            <!-- 'chkcatarr' checks if the category Array is empty and therefore shows the overlay over this select box instead of letting users bring down an empty select box -->
                            <b-overlay :show="chkcatarr" rounded opacity="0.6" spinner-type="grow" spinner-small spinner-variant="primary" class="w-100">
                                <b-form-select v-model="topicObj.category" :options="Categoriesarray" @change="categoryChanged">
                                    <b-form-select-option value="null">--Select category--</b-form-select-option>
                                </b-form-select>
                            </b-overlay>
                        </b-form-group>

                        <b-form-group class="nested-form-group" v-if="sameName == 'No'" label="Select Institution" label-for="institution">
                            <b-form-select v-model="topicObj.institution" @change="institutionChanged" :options="institutionsarray">
                                <b-form-select-option value="null">--Select Institution--</b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.institution != null" label="Select Level" label-for="institution">
                            <b-form-select v-model="topicObj.level" @change="levelChanged" :options="levelsarray">
                                <b-form-select-option value="null">--Select Level--</b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.level != null" label="Select Course" label-for="institution">
                            <b-form-select v-model="topicObj.topicfor" :options="coursesarray">
                                <b-form-select-option value="null">--Select Course--</b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="nested-form-group" v-if="structure == 'Subject' && topicObj.institution != null" label="Select Subject" label-for="institution">
                            <b-form-select v-model="topicObj.topicfor" :options="subjectOptions">
                                <b-form-select-option value='null'>--Select Subject--</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="How many Topics are being Uploaded?" label-for="markper">
                            <b-form-spinbutton
                                id="markper"
                                v-model="topicsinfile"
                                min="1"
                                max="100"
                                step="1"
                            ></b-form-spinbutton>
                        </b-form-group>
                        <h2 class="text-center m-3">Upload {{ mtype == 'added' ? 'another' : ''}} Topic File <b-icon-cloud-upload></b-icon-cloud-upload></h2>
                        <b-overlay :show="uploadingfile">
                            <template #overlay>
                                <div class="text-center">
                                    <b-icon-file-image font-scale="3" animation="throb"></b-icon-file-image>
                                    <p>Uploading File... Checking Semantics</p>
                                </div>
                            </template>
                            <b-form-group>
                                <b-form-file :disabled="chkentries" variant="warning" v-model="filelink" ref="topicfile" placeholder="Choose a file or drop it here" drop-placeholder="Drop File here..." @input="handleFileUpload"></b-form-file>
                            </b-form-group>

                        </b-overlay>
                        
                        <div v-if="mtype == 'Ready!'">
                            <div class="alert" :class="countsynced == true ? 'alert-success' : 'alert-danger'">{{ uploadmessage }}</div>
                            <h3 class="text-center">There are {{ topicscount }} Topics{{ topicscount > 1 ? 's' : ''}} in this File</h3>
                            
                            <div class="sqheader p-2 m-1">
                                <div class="heasub"><h3>Review the Topics{{ topicscount > 1 ? 's' : ''}} before Adding them to the Database</h3></div>
                                <div class="sqicon">
                                    <b-icon-plus font-scale="2.5" v-if="showplus2" @click="showplus2 = false;showreview = true; showminus2 = true" class="sqbicon"></b-icon-plus>

                                    <b-icon-dash font-scale="2.5" v-if="showminus2" @click="showreview = false; showminus2 = false; showplus2 = true " class="sqbicon"></b-icon-dash>
                                </div>
                            </div>

                            <div v-if="showreview">
                                <b-card class="txtcode" bg-variant="dark" text-variant="light">
                                    <code v-html="reviewupload">

                                    </code>
                                </b-card>
                            </div>
                            <div v-if="mtype == 'added'" class="alert alert-success">Topic{{ topicscount > 1 ? 's' : ''}} has been added to the database</div>
                            <b-form-group class="text-center mt-3">
                                <b-overlay :show="adding" rounded opacity="0.6" spinner-small spinner-variant="primary" class="">
                                    <b-button :disabled="!countsynced" @click="addFileTopics"  size="lg" type="submit" class="btn-sub p-1 w-50" variant="primary">
                                        Add Topics to Database
                                    </b-button>
                                </b-overlay>
                            </b-form-group>
                        </div>

                            
                       


                    </b-card>
                    
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>

<script>
import store from "@/store"
import axios from "axios"
import { mapState, mapActions } from "vuex"

export default {
    data(){
        return {
            chkcatarr : false,
            topicObj : this.getTopic(),
            addmethod : "Text",
            Categoriesarray : [],
            institutionsarray : [],
            levelsarray : [],
            coursesarray : [],
            subjectOptions : [],
            proceeding : false,
            added : false,
            uploadingfile : false,
            uploadedfilelink : "",
            filedir : "",
            mtype : "",
            reviewupload : "",
            topicscount : 0,
            adding : false,
            topicsinfile : 1,
            showformatting : false,
            showminus : false,
            showplus : true,
            showminus2: true,
            showplus2 : false,
            uploadmessage : "",
            countsynced : false,
            showreview : true,
            filelink : "",
            structure : "",
            sameName : "",
            org : ""
        }
    },
    created(){
        this.org = this.details.clearance_organization
        if (this.Categories.length > 0) { // If the category Array has been populated by the response from the Api
            let inst = this.allinsti.filter(x => x.available == "Yes").map(x => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

            this.institutionsarray = inst; // set the Data property institutionsarray with this value
            let typesarr = this.Categories.filter(x => x.organization_name == this.details.clearance_organization).map(x => x.name); // Get the Categories and map their names to the 'typesarray'
            this.Categoriesarray = typesarr; // set the value of the data property 'Categoriesarray' to this value
        } else {
            // If the initial API call did not send back the response on time, dispatch another request and this time wait for the request to send a response before doing any further operation
            store.dispatch("admin/fetchCategories").then(() => {
                store.dispatch("admin/fetchInstitutions");

                let inst = this.allinsti.filter(x => x.available == "Yes").map(x => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

                this.institutionsarray = inst; // set the Data property institutionsarray with this value
                let typesarr = this.Categories.map(x => x.name); // Get the Categories and map their names to the 'typesarray'
                this.Categoriesarray = typesarr; // set the value of the data property 'Categoriesarray' to this value
            });
        }
    },
    mounted(){

    },
    methods: {
        ...mapActions("admin", ["setTopic","setTopicFileObj"]),
        addTopic(){
            return this.setTopic(this.topicObj).then(() => {
                this.topicObj.topic = ""
                this.proceeding = false
                this.added = true
            })
        },
        getTopic(){
            return{
                topic : "",
                topicfor : null,
                institution : null,
                category : null,
                level : null,
                organization : "",
                adminname: this.$store.state.loginmaster.details.fullname,
                admintrackid: this.$store.state.loginmaster.details.trackid,
            }
        },
        categoryChanged() {
            this.topicObj.institution = null // If the type is changed, reset the select Object. set the institution property to null
            this.institutionsarray = [] // Empties the Institutions Array
            this.topicfor = null

            let org = this.details.clearance_organization;

            let inst = this.allinsti
                .filter((x) => x.available == "Yes" && x.category == this.topicObj.category && x.organization_name == org)
                .map((x) => x.name);

            // console.log(inst)
            this.institutionsarray = inst;

            this.topicObj.organization = org
            let tabi = this.Categories.filter(
                (x) => x.organization_name == org && x.name == this.topicObj.category
            ).map((x) => x.structure);
            this.structure = tabi[0];

            let sameName = this.Categories.filter(
                (x) => x.organization_name == org && x.name == this.topicObj.category
            ).map((x) => x.sameName);
            this.sameName = sameName[0]

            if(this.sameName == "Yes") {
                this.topicObj.institution = this.topicObj.category
                let subbb = this.allinsti
                    .filter((x) => x.name == this.topicObj.category && x.organization_name == org)
                    .map((x) => x.subjects_offered);
                this.subjectOptions = JSON.parse(subbb);
            }
            // let inst = this.allinsti.filter(x => x.available == "Yes" && x.category == this.topicObj.category).map(x => x.name);
            // this.institutionsarray = inst;
            

            // if (this.topicObj.category == "JAMB") {

            //     this.topicObj.institution = "JAMB";

            //      // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
            //     let unparsedSubjects = this.allinsti.filter(x => x.name == this.topicObj.institution && x.category == this.topicObj.category).map(x => x.subjects_offered);

            //     this.subjectOptions = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectOptions' to it
            // }
        },
        institutionChanged() {
            this.levelsarray = [] // Anytime user changes Institution, empty the levelsarray

            // If the selected category to be taken is undergraduate
            if (this.structure == "Section") {
                // Get the levels config Object for this particular institution under the undergraduate category
                // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
                let unparsedLevelConfig = this.allinsti.filter(x => x.category == this.topicObj.category && x.name == this.topicObj.institution && x.organization_name == this.org).map(x => x.levels_config);
                let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
        
                // Get the name of each level available in the levels config. It should return "['100', '200']" depending on the levels available in the Configurations Object
                this.levelsarray = parsedLevelConfig.map(x => x.name);
               

            } else {
                // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
                let unparsedSubjects = this.allinsti.filter(x => x.name == this.topicObj.institution && x.category == this.topicObj.category && x.organization_name == this.org).map(x => x.subjects_offered);
                this.subjectOptions = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectOptions' to it
            }
        },

        levelChanged() {
            this.coursesarray = []
             // Get the levels config Object for this particular institution under the undergraduate category
            // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
            let unparsedLevelConfig = this.allinsti.filter(x => x.category == this.topicObj.category && x.name == this.topicObj.institution && x.organization_name == this.org).map(x => x.levels_config);
            let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
            
            // Get the Chosen Level exact config Array.
            // To see output. Console.log(config) in development mode
            let config = parsedLevelConfig.filter(x => x.name == this.topicObj.level).map(x => x.config);
            // Now get the Courses from the courses Object of the Chosen level exact config Object
            let courses = config[0].filter(x => x.name == "courses").map(x => x.values);

            // Inject this Array into the general courses Array for Selection
            this.coursesarray = courses[0];
        },
        handleFileUpload() {
            let filelength =  this.$refs.topicfile.files[0].name.length

            if(filelength > 0){

                this.uploadingfile = true;
                let ifile = this.$refs.topicfile.files[0];
                let formData = new FormData();

                formData.append("filetoupload", ifile);
                formData.append("uploadcategory", "Topic")
                formData.append("environment", this.environ)
                formData.append("blocksinfile", this.topicsinfile)
                // formData.append("environment", this.environ)
                formData.append("origin", this.origin)
                formData.set("category", this.topicObj.category)
                formData.set("institution", this.topicObj.institution)
                formData.set("topicfor", this.topicObj.topicfor)
                formData.set("organization", this.topicObj.organization)
                formData.set("adminname", this.topicObj.adminname)
                formData.set("admintrackid", this.topicObj.admintrackid)

                formData.append('pretag', 'topics')
                let apilink = this.environ == 'development' ? `${this.origin}/Filehandler.php` : `${this.origin}/Filehandler.php`
                // let apilink = this.environ == 'development' ? "http://localhost/quicktest/src/apis/topicFilehandler.php" : "https://quicktest.futavilla.com/apis/topicFilehandler.php"

                axios.post(apilink,formData, { header: {
                                "Content-Type": "multipart/form-data",
                            },
                        }).then((response) => {
                            this.uploadingfile = false;
                            this.mtype = response.data.mtype
                            this.reviewupload = response.data.stringedblocks
                            this.topicscount = response.data.countblocks
                            this.countsynced = response.data.countedsync
                            this.uploadmessage = response.data.message
                            this.filelink = ""
                            this.$bvModal.msgBoxOk("Topics File Uploaded. Check for errors, confirm the number of topics to be added to the Database and Proceed wiith the Operation.", {
                                title: "Topic File Uploaded",
                                size: "xs",
                                centered: true,
                            }).then(() => {});
                            this.filedir = response.data.filedir;
                        
                        //console.log(response.data);
                    }).catch((error) => {
                        console.log(error)
                        this.$bvModal
                            .msgBoxOk("Check your Network Connection. Could not upload Topic File.", {
                                title: "No Network Connection",
                                size: "xs",
                                centered: true,
                            })
                            .then(() => {
                                this.filelink = ""
                                this.uploadingfile = false;
                                
                            });
                        //console.log(error);
                    });
            }
        },
        addFileTopics(){
            this.adding = true;
            let addObj = {
                adminname: this.$store.state.loginmaster.details.fullname,
                admintrackid: this.$store.state.loginmaster.details.trackid,
                topicfor : this.topicObj.topicfor,
                institution : this.topicObj.institution,
                category : this.topicObj.category,
                organization: this.topicObj.organization,
                level : this.topicObj.level,
                filedir : this.filedir
            }
            this.setTopicFileObj(addObj).then(() => {
                this.adding = false
                this.mtype = "added"
                this.topicObj.topicfor = null
            })
        },
        proceed() {
            this.proceeding = true; // Set value of the data property 'proceeding' to true. This triggers the spinner to come up and also disables the proceed button
        },
        stopproceed() {
            this.proceeding = false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
        },
    },
    computed : {
        ...mapState({
            allinsti: (state) => state.admin.listinstitutions,
            Categories: state => state.admin.Categories,
            environ : state => state.loginmaster.environ,
            details : state => state.loginmaster.details,
            origin : (state) => state.loginmaster.api_origin
        }),
        substate(){
            return this.topicObj.topic.length == 0 || this.topicObj.institution == 'Post UTME' ? false : true
        },
        chkentries(){
            return this.topicObj.category == null || this.topicObj.institution == null || this.topicObj.topicfor == null || this.topicObj.topicfor == 'null' ? true : false
        }
    }
}
</script>

<style scoped>
.active-method {
    background-color: rgb(8, 8, 238);
}

.inactive-method {
    background-color: rgba(128, 128, 136, 0.74);
    ;
}
.txtformat{
    font-size: 14px;
    line-height: 10px;
    white-space: nowrap
}
.txtcode{
    overflow : auto
}
.sqheader {
    font-size: 1.2rem;
    background-color: rgb(240, 231, 231) ;
    border-radius: 10px 10px;
    display: flex;
    font-weight: bold;
}
.heasub {
    width: 70%;
}

.sqicon {
    width: 30%;
    text-align: right;
    cursor: pointer
}

</style>